export enum Colors {
    Main = "#0f0f0f",
    Secondary = "#535762",
    Ink = "#AFB6CD",
    DarkText = "#252a41",
    LightText = "#F7F9FB",
    LightBorder = "rgba(175, 182, 205, 0.15)",
    DarkBorder = "rgba(0, 0, 0, 0.13)",
}

export enum SystemColos {
    Success = "#4ca83d",
    Danger = "#dc3434",
    Info = "#33a7e2",
    Warning = "#ff8700",
    Ink = "#AFB6CD",
    Purple = "#b548c6",
}

export type SystemColosType =
    | "Success"
    | "Danger"
    | "Info"
    | "Warning"
    | "Ink"
    | "Purple";
